import { render } from "./SmGroupProperties.vue?vue&type=template&id=a527660a&scoped=true"
import script from "./SmGroupProperties.vue?vue&type=script&lang=js"
export * from "./SmGroupProperties.vue?vue&type=script&lang=js"

import "./SmGroupProperties.vue?vue&type=style&index=0&id=a527660a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a527660a"]])

export default __exports__